import Gift from "components/Gift";
import GiftError from "components/Gift/components/GiftError";
import GiftSuccess from "components/Gift/components/GiftSuccess";
import GiftDetails from "components/Gift/components/GiftDetails";
import GiftCompliance from "components/Gift/components/GiftCompliance";
import GiftAbout from "components/Gift/components/GiftAbout";
import GiftReview from "components/Gift/components/GiftReview";
import GiftOccasion from "components/Gift/components/GiftOccasion";

export default {
  path: 'gift',
  Component: Gift,
  children: [
    { index: true, Component: GiftAbout },
    { path: 'error', Component: GiftError },
    { path: 'details', Component: GiftDetails },
    { path: 'compliance', Component: GiftCompliance },
    { path: 'review', Component: GiftReview },
    { path: 'success', Component: GiftSuccess },
    { path: 'occasion', Component: GiftOccasion },
    { path: ':id', Component: GiftAbout }
  ]
};
